import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { SignInButton } from './SignInButton';
import Plantilla from '../plantillas/Plantilla';

/**
 * Renders the login page
 */
export default function Office365Login() {
    return (<>
        <Container className='home' >
            <Row >
                <Col>
                    <Plantilla id="Login" />
                </Col>
            </Row>
            <Row style={{ marginBlock: "30px" }}>
                <Col>
                    <div className="d-grid gap-2">
                        <SignInButton />
                    </div>
                </Col>
            </Row>
        </Container>
    </>);
};
